// eslint-disable-next-line import/no-anonymous-default-export
export default {
    NAO: 0,
    SIM: 1
}